import { Inbox } from "lucide-react";
import { Link } from "react-router-dom";

export default function EmptyState({ icon: Icon = Inbox, title, description, ctaLabel, ctaTo, onCta, testid, compact = false }) {
  if (compact) {
    return (
      <div data-testid={testid} className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 py-6 text-center text-sm text-slate-400">
        <span>{title}</span>
        {ctaLabel && <><span className="text-slate-600">·</span>
          {ctaTo ? <Link to={ctaTo} data-testid={`${testid}-cta`} className="inline-flex min-h-11 items-center font-medium text-slate-100 hover:underline md:min-h-0">{ctaLabel}</Link>
            : <button data-inline onClick={onCta} data-testid={`${testid}-cta`} className="inline-flex min-h-11 items-center font-medium text-slate-100 hover:underline md:min-h-0">{ctaLabel}</button>}</>}
      </div>
    );
  }
  return (
    <div data-testid={testid} className="athanor-card p-10 text-center fade-up">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-surface-2">
        <Icon className="h-5 w-5 text-slate-400" />
      </div>
      <h3 className="text-lg font-semibold text-slate-100">{title}</h3>
      {description && <p className="mx-auto mt-2 max-w-md text-sm text-slate-400">{description}</p>}
      {ctaLabel &&
        (ctaTo ? (
          <Link to={ctaTo} data-testid={`${testid}-cta`} className="btn btn-primary mt-5">{ctaLabel}</Link>
        ) : (
          <button onClick={onCta} data-testid={`${testid}-cta`} className="btn btn-primary mt-5">{ctaLabel}</button>
        ))}
    </div>
  );
}
